import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PaginatedFetchTable from '../../PaginatedFetchTable';
import Avatar from '../../Avatar';
import Score from '../../Score';
import StatusPill from '../../StatusPill';
import ModalTrigger from '../../ModalTrigger';
import DateTimeDisplay from '../../DateTimeDisplay';


export default class StaffFeedbacksSubmittedList extends Component {
  static propTypes = {
    timezone: PropTypes.string,
    apiUrl: PropTypes.string,
    perPage: PropTypes.number.isRequired,
    emptyImg: PropTypes.string.isRequired,
    defaultSort: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      className: PropTypes.string,
      sort: PropTypes.shape({
        id: PropTypes.string.isRequired,
        direction: PropTypes.oneOf(['asc', 'desc']).isRequired,
      }),
    })).isRequired,
  };

  static defaultProps = {
    timezone: moment.tz.guess(),
    defaultSort: null,
    apiUrl: '',
  }

  renderRow = (item) => (
    <tr key={item.id}>
      <td>
        <a href={item.about.staff_url}>
          <div className="u-flex u-items-center">
            {item.about.type !== 'event' && (
              <Avatar
                className="StaffTable-avatar u-mr-2"
                src={item.about.avatar_url}
                type={item.about.type}
                showInitials
                name={item.about.name}
              />
            )}
            <div className="u-font-semibold u-truncate">
              {item.about.name}
            </div>
          </div>
        </a>
      </td>
      <td>
        <div className="u-truncate">
          <Score rating={item.recommend} />
        </div>
      </td>
      <td>
        <div className="u-truncate">
          <StatusPill status={item.comment} />
        </div>
      </td>
      <td>
        <a href={item.author.staff_url}>
          <div className="u-flex u-items-center">
            <Avatar
              className="StaffTable-avatar u-mr-2 "
              src={item.author.avatar_url}
              type="user"
              showInitials
              name={item.author.name}
                />
            <div className="u-font-semibold u-truncate">
              {item.author.name}
            </div>
          </div>
        </a>
      </td>
      {item.about.type !== 'event' && (
        <td>
          {item.source && (
          <a className="u-truncate u-font-semibold u-block" href={item.source.staff_url}>{item.source.name}</a>
          )}
        </td>
      )}
      <td>
        <DateTimeDisplay useTimezone={this.props.timezone} timestamp={item.updated_at} date_only />
      </td>
      <td className="actions">
        <ModalTrigger
          async
          asyncUrl={item.preview_url}
          triggerClassName="Button"
          modalWrapperClassName="compact"
          triggerIcon="Icon Icon-view"
          triggerIconClassName="u-mr-0"
          />
      </td>
    </tr>
  )

  render() {
    const {
      apiUrl, perPage, emptyImg, columns, defaultSort,
    } = this.props;
    return (
      <PaginatedFetchTable
        apiUrl={apiUrl}
        perPage={perPage}
        emptyImg={emptyImg}
        columns={columns}
        defaultSort={defaultSort}
        renderRow={this.renderRow}
      />
    );
  }
}
